/*
 * This file is part of justoverclock/custom-header.
 *
 * Copyright (c) 2021 Marco Colia.
 * https://flarum.it
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/extend';
import app from 'flarum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import Carousel from 'hero-carousel';
import Page from "flarum/common/components/Page";

app.initializers.add('justoverclock/header-slideshow', () => {
    extend(IndexPage.prototype, 'view', function (vdom) {
        if (vdom.children && vdom.children.splice) {

            const slides = [];
            for (let i = 1; i < 5; i++) {
                if (app.forum.attribute(`Link${i}`)) {
                    slides.push(m('a', { className: 'carousel__slide', href: app.forum.attribute(`Link${i}`) }, [
                        m('img', { className: 'carousel__slide-image', src: app.forum.attribute(`Image${i}`) }),
                    ]))
                }
            }

            const insert = m('div', { className: 'container' }, [
                m('div', { className: 'carousel' }, [
                    m('div', { className: 'carousel__slides', tabindex: '0' }, slides),
                    m('div', { className: 'carousel__controls' }),
                ])]);
            vdom.children.splice(1, 0, insert);
        }
    });
    extend(IndexPage.prototype, 'oncreate', function (vnode) {
        new Carousel(document.querySelector('.carousel'), (app.forum.attribute('TransitionTime') || 5) * 1000);
    });
});
